/* eslint-disable react-hooks/exhaustive-deps */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Resizable } from "re-resizable";
import {
  FunctionComponent,
  ReactNode,
  useCallback,
  useEffect,
  useState,
} from "react";
import Draggable from "react-draggable";

import useViewportDimensions from "../../../../hooks/viewport/useViewportDimensions";
import FlowioErrorBoundary from "../../../atoms/FlowioErrorBoundary";
import Loader from "../../../atoms/Loader";
import FlowioModal, { ModalSizes } from "../../FlowioModal";

type BoundaryType = {
  top: number;
  left: number;
  right: number;
  bottom: number;
};

type NoFooterModalProps = {
  isOpen: boolean;
  toggle: () => void;
  title?: string;
  size?: ModalSizes;
  isLoading?: boolean;
  children?: ReactNode;
};

const DEFAULT_BOUNDARY: BoundaryType = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

const NoFooterModal: FunctionComponent<NoFooterModalProps> = ({
  isOpen,
  toggle,
  title,
  children,
  isLoading = false,
  size,
}) => {
  const [modalRef, setModalRef] = useState<HTMLDivElement | null>(null);
  const [modalWidth, setModalWidth] = useState(0);
  const [modalHeight, setModalHeight] = useState(0);
  const [boundary, setBoundary] = useState<BoundaryType>(DEFAULT_BOUNDARY);

  const { x, y } = useViewportDimensions();

  const updateBoundaries = (clientWidth: number, clientHeight: number) => {
    const horizontalBounds = (x - clientWidth) / 2;
    setBoundary({
      top: -40,
      bottom: y - clientHeight - 40,
      left: horizontalBounds * -1,
      right: horizontalBounds,
    });
  };

  // tenhle use effect pouzivam proto, abych prenastavil boundaries kdyz dojde ke zmene velikosti okna prohlizece
  useEffect(() => {
    updateBoundaries(modalWidth, modalHeight);
  }, [x, y]);

  // rucne nastavim referenci a zaroven velikost modalu (abych mohl urcit boundaries pro draggable)
  const onRefChange = useCallback((ref: HTMLDivElement | null) => {
    const isFirstRender = modalRef === null;
    setModalRef(ref);
    if (isFirstRender && ref) {
      updateBoundaries(ref.clientWidth, ref.clientHeight);
      setModalWidth(ref.clientWidth);
      setModalHeight(ref.clientHeight);
    }
  }, []);

  // Is here for performance protection from Draggable
  if (!isOpen) {
    return null;
  }

  return (
    <Draggable bounds={boundary} handle=".drag-handle">
      <FlowioErrorBoundary>
        <FlowioModal
          title={title ?? ""}
          toggle={toggle}
          isOpen={isOpen}
          size={size}
          ref={onRefChange}
        >
          <Resizable
            defaultSize={{ width: "auto", height: "auto" }}
            style={{ position: "static" }}
          >
            <FlowioErrorBoundary>
              {isLoading ? <Loader /> : children}
            </FlowioErrorBoundary>
          </Resizable>
        </FlowioModal>
      </FlowioErrorBoundary>
    </Draggable>
  );
};

export default NoFooterModal;
